import {filterEmptyKeys} from "@/lib/utils";

/**
 * Generate a cache key for swr.
 *
 * @param route  The route to generate the cache key for.
 * @param params The parameters to include in the cache key.
 */
export function cacheKey(route: string, params?: unknown): string {
    if (params) {
        const queryString: string = new URLSearchParams(flattenObject(filterEmptyKeys(params as GenericParams))).toString();

        return `${route}?${queryString}`;
    }

    return route;
}

/**
 * Flatten an object into a single level object with dot notation for nested keys.
 *
 * @param obj
 * @param parentKey
 * @param res
 */
const flattenObject = (obj: Record<string, string>, parentKey = "", res: Record<string, string> = {}): Record<string, string> => {
    for (const key in obj) {
        const propName = parentKey ? `${parentKey}.${key}` : key;
        if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            flattenObject(obj[key] as Record<string, string>, propName, res);
        } else {
            res[propName] = obj[key];
        }
    }
    return res;
};

export interface GenericParams {
    [key: string]: string | number | boolean | undefined | null | string[];
}
